import { render } from "./ReleaseFile.vue?vue&type=template&id=b9b26450&scoped=true"
import script from "./ReleaseFile.vue?vue&type=script&lang=js"
export * from "./ReleaseFile.vue?vue&type=script&lang=js"

import "./ReleaseFile.vue?vue&type=style&index=0&id=b9b26450&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9b26450"]])

export default __exports__